/* A second control for the existing form, not a second cart implementation. */
if (!customElements.get('ff-mobile-buy')) {
  customElements.define('ff-mobile-buy', class extends HTMLElement {
    connectedCallback() {
      this.info = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.source = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
      this.button = this.querySelector('button');
      if (!this.info || !this.source || !this.button) return;

      this.onClick = () => {
        this.sync();
        if (!this.button.disabled) this.source.click();
      };
      this.button.addEventListener('click', this.onClick);
      this.onInput = () => this.sync();
      this.info.addEventListener('input', this.onInput);
      this.info.addEventListener('change', this.onInput);
      this.observer = new MutationObserver((records) => {
        if (records.some((record) => !this.contains(record.target))) this.sync();
      });
      this.observer.observe(this.info, { attributes: true, childList: true, characterData: true, subtree: true });
      this.visibilityObserver = new IntersectionObserver(([entry]) => {
        this.toggleAttribute('hidden', entry.isIntersecting && entry.intersectionRatio >= 0.9);
      }, { threshold: [0, 0.9, 1] });
      this.visibilityObserver.observe(this.source);
      this.errorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
        if (String(event.productVariantId) !== this.info.querySelector('.product-variant-id')?.value) return;
        // Let the native form display its error before moving the user to it.
        requestAnimationFrame(() => {
          const error = this.info.querySelector('.product-form__error-message-wrapper:not([hidden])');
          if (!error) return;
          error.setAttribute('tabindex', '-1');
          error.scrollIntoView({ block: 'center', behavior: 'auto' });
          error.focus({ preventScroll: true });
        });
      });
      this.classList.add('is-ready');
      this.sync();
    }

    sync() {
      const busy = this.source.classList.contains('loading');
      const disabled = this.source.disabled || this.source.getAttribute('aria-disabled') === 'true';
      if (this.button.disabled !== disabled) this.button.disabled = disabled;
      if (this.button.getAttribute('aria-busy') !== String(busy)) this.button.setAttribute('aria-busy', String(busy));
      const label = busy ? this.dataset.addingLabel : this.source.querySelector('span')?.textContent.trim();
      const labelTarget = this.querySelector('[data-buy-label]');
      if (labelTarget.textContent !== label) labelTarget.textContent = label;
      const price = this.info.querySelector('[id^="price-"]');
      const amount = price?.querySelector('.price--on-sale .price-item--sale, .price:not(.price--on-sale) .price__regular .price-item--regular');
      const priceText = price?.classList.contains('hidden') ? '' : (amount?.textContent.trim() || '');
      const priceTarget = this.querySelector('[data-buy-price]');
      if (priceTarget.textContent !== priceText) priceTarget.textContent = priceText;
      const quantity = this.info.querySelector('[name="quantity"]')?.value || '1';
      const quantityTarget = this.querySelector('[data-buy-quantity]');
      if (quantityTarget.textContent !== `Qty ${quantity}`) quantityTarget.textContent = `Qty ${quantity}`;
      const popup = this.source.getAttribute('aria-haspopup');
      if (popup && this.button.getAttribute('aria-haspopup') !== popup) this.button.setAttribute('aria-haspopup', popup);
      if (!popup && this.button.hasAttribute('aria-haspopup')) this.button.removeAttribute('aria-haspopup');
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.visibilityObserver?.disconnect();
      this.errorUnsubscriber?.();
      this.button?.removeEventListener('click', this.onClick);
      this.info?.removeEventListener('input', this.onInput);
      this.info?.removeEventListener('change', this.onInput);
    }
  });
}
